<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="PARÂMETROS DE E-MAIL"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/email.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <button data-toggle="modal" data-target="#dialogTestar"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/email_forward.png" alt="Testar" title="Testar configurações" height="22"
              width="22">
          </button>
          <button *ngIf="podeIncluir()" (click)="submitForm()" type="submit"
            class="btn btn-info float-right mr-2" style="font-size: 13px">Salvar</button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="row">
        <div class="col-md-9">
          <label style="color: #757575; border-bottom: 1px solid #e5e5e5; display: block">Autenticação</label>
          <div class="row">
            <div class="col-md-4">
              <label for="email">E-mail
                <span class="text-danger">*</span>
              </label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="O endereço de email do remetente. Podem ser simples 'teste@teste.com' ou formatados 'Nome do Remetente <teste@teste.com>'">
                ?</span>
              <input #email_ id="email" formControlName="email" type="text" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="user">Usuário<span class="text-danger">*</span></label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Nome de usuário">
                ?</span>
              <input id="user" formControlName="user" type="text" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="password">Senha<span class="text-danger">*</span></label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Senha do usuário">
                ?</span>
              <input id="password" formControlName="password" type="password" class="form-control">
            </div>
          </div>
          <label class="mt-3 mb-2" style="color: #757575; border-bottom: 1px solid #e5e5e5; display: block">Servidor de
            E-mail</label>
          <div class="row">
            <div class="col-md-4">
              <label for="host">Servidor<span class="text-danger">*</span></label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Nome do host ou o endereço IP ao qual se conectar">
                ?</span>
              <input id="host" formControlName="host" type="text" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="port">Porta<span class="text-danger">*</span></label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Porta à qual se conectar (o padrão é 587 se não for seguro ou 465 se for verdadeiro)">
                ?</span>
              <input id="port" formControlName="port" type="number" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="proxy">Proxy</label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Todos os transportes baseados em SMTP permitem usar proxies para fazer conexões TCP com servidores">
                ?</span>
              <input id="proxy" formControlName="proxy" type="text" class="form-control">
            </div>
          </div>
          <label class="mt-3 mb-2" style="color: #757575; border-bottom: 1px solid #e5e5e5; display: block">Tempo de
            espera</label>
          <div class="row">
            <div class="col-md-4">
              <label for="connectionTimeout">Conexão</label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Quantos milissegundos de espera para a conexão ser estabelecida (o padrão é 2 minutos)">
                ?</span>
              <input id="connectionTimeout" formControlName="connectionTimeout" type="number" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="gretingTimeout">Validação</label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Quantos milissegundos esperar após o estabelecimento da conexão (o padrão é 30 segundos)">
                ?</span>
              <input id="gretingTimeout" formControlName="gretingTimeout" type="number" class="form-control">
            </div>
            <div class="col-md-4">
              <label for="socketTimeout">Inatividade</label>
              <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip" data-placement="top"
                title="Quantos milissegundos de inatividade são permitidos (o padrão é 10 minutos)">
                ?</span>
              <input id="socketTimeout" formControlName="socketTimeout" type="number" class="form-control">
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label style="color: #757575; border-bottom: 1px solid #e5e5e5; display: block">Outras configurações</label>
          <div class="row">
            <div class="form-group">
              <div class="checkbox checbox-switch mt-2 switch-success">
                <label>
                  <input formControlName="secure" type="checkbox" />
                  <span></span>
                  Conexão Segura
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se verdadeiro, a conexão usará TLS ao se conectar ao servidor. Se falso (o padrão), o TLS será usado se o servidor suportar a extensão STARTTLS. Na maioria dos casos, configure esse valor como true se você estiver se conectando à porta 465. Para as portas 587 ou 25, mantenha-o falso">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-success">
                <label>
                  <input formControlName="ignoreTLS" type="checkbox" />
                  <span></span>
                  Ignorar TLS
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se isso for verdadeiro e seguro for falso, o TLS não será usado, mesmo que o servidor suporte a extensão STARTTLS">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-success">
                <label>
                  <input formControlName="requireTLS" type="checkbox" />
                  <span></span>
                  Requerer TLS
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se isso é verdadeiro e seguro é falso, o Nodemailer tenta usar o STARTTLS, mesmo se o servidor não anunciar suporte para ele. Se a conexão não puder ser criptografada, a mensagem não será enviada">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-warning">
                <label>
                  <input formControlName="disableFileAccess" type="checkbox" />
                  <span></span>
                  Não permitir arquivos
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se verdadeiro, não permite usar arquivos como conteúdo. Use-o quando desejar usar dados JSON de origem não confiável como o email. Se um nó de anexo ou mensagem tentar buscar algo de um arquivo, o envio retornará um erro">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-warning">
                <label>
                  <input formControlName="disableUrlAccess" type="checkbox" />
                  <span></span>
                  Não permitir URLs
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top" title="Se verdadeiro, não permite usar URLs como conteúdo">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-danger">
                <label>
                  <input formControlName="logger" type="checkbox" />
                  <span></span>
                  Ativar logs
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se definido como true, registra-se no console. Se o valor não estiver definido ou estiver false, nada será registrado">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-danger">
                <label>
                  <input formControlName="debug" type="checkbox" />
                  <span></span>
                  Ativar Depuração
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se definido como true, registra o tráfego SMTP, caso contrário, registra apenas eventos de transação">
                  ?</span>
              </div>
              <div class="checkbox checbox-switch mt-2 switch-danger">
                <label style="color: #dc3545;">
                  <input formControlName="disabled" type="checkbox" />
                  <span></span>
                  Desativar configurações
                </label>
                <span style="font-weight: bold; color: #75758b; float: right;" data-toggle="tooltip"
                  data-placement="top"
                  title="Se isso for verdadeiro, as configurações de e-mail são ignoradas e o envio é feito por configurações padrões">
                  ?</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>

<div class="modal fade" id="dialogTestar" tabindex="-1" role="dialog" aria-labelledby="Testar" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Testar configurações de e-mail</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="card">
          <div class="card-header">
            Informe um endereço de e-mail para verificar se as configurações estão corretas
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label for="destinatario">E-mail destinatário</label>
                <input [(ngModel)]="destinatario" class="form-control" id="destinatario" />
              </div>
            </div>
          </div>
          <div class="card-footer p-3">
            <button (click)="testar()" type="submit" class="btn btn-info btn-sm float-right ml-2">Enviar</button>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
